<div class="card">
    <div class="card-header">
        <h4>Super Transactions</h4>
    </div>
    <div class="card-body m-0">
        <div class="row mb-0" style="min-height: 470px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                <ag-grid-angular [enableCellTextSelection]=true
                    [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)" 
                    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                    [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
                    [rowSelection]="'single'" [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                </ag-grid-angular>
            </div>
        </div>
        <div class="row mt-0">
            <div class="col-4 col-xs-4 d-flex">
                <select (change)="refreshData($event)" [(ngModel)]="pageSize"
                    class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
                    <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
                </select>
                <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
            </div>
            <div class="col-8 col-xs-8">
                <ngb-pagination  (pageChange)="updatePage($event)" [(page)]="currentPage" [boundaryLinks]="true"
                    [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false"
                    [directionLinks]="true" [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
                </ngb-pagination>
            </div>
        </div>
    </div>
</div>

<app-modal #modalSuperTransaction [modalConfig]="modalSuperTransactionConfig" style="width: 1200px;">

    <h4 class="text-center">Super Transaction</h4>
    <div *ngIf="searchedSuperTransaction">
        <div class="row">
            <div class="col-sm-4">
                <label class="col-form-label" for="txnId">Transaction ID
                </label>
                <input class="form-control" id="txnId" readonly [(ngModel)]="searchedSuperTransaction.txnId" type="text"
                    name="txnId">
            </div>
            <div class="col-sm-4">
            </div>
            <div class="col-sm-4">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="senderWalletId">Debit Wallet ID</label>
                <input class="form-control" readonly id="senderWalletId" type="text"
                    [(ngModel)]="searchedSuperTransaction.senderWalletId" name="senderWalletId">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="senderMobileNumber">Sender Mobile Number</label>
                <input class="form-control" readonly id="senderMobileNumber" type="text"
                    [(ngModel)]="searchedSuperTransaction.senderMobileNumber" name="senderMobileNumber">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="senderName">Sender Name</label>
                <input class="form-control" readonly id="senderName" type="text" [(ngModel)]="searchedSuperTransaction.senderName"
                    name="senderName">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="receiverWalletId">Credit Wallet ID</label>
                <input class="form-control" readonly id="receiverWalletId" type="text"
                    [(ngModel)]="searchedSuperTransaction.receiverWalletId" name="receiverWalletId">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="receiverMobileNumber">Receiver Mobile Number</label>
                <input class="form-control" readonly id="receiverMobileNumber" type="text" [(ngModel)]="searchedSuperTransaction.receiverMobileNumber"
                    name="receiverMobileNumber">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="receiverName">Receiver Name</label>
                <input class="form-control" readonly id="receiverName" type="text" [(ngModel)]="searchedSuperTransaction.receiverName"
                    name="receiverName">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="senderVirtualIBAN">Sender IBAN</label>
                <input class="form-control" readonly id="senderVirtualIBAN" type="text" [(ngModel)]="searchedSuperTransaction.senderVirtualIBAN"
                    name="senderVirtualIBAN">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="channelId">Channel ID</label>
                <input class="form-control" readonly id="channelId" type="text" [(ngModel)]="searchedSuperTransaction.channelId"
                    name="channelId">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="transactionDate">Date of Transaction</label>
                <input class="form-control" readonly id="transactionDate" type="text"
                    [(ngModel)]="searchedSuperTransaction.transactionDate" name="transactionDate">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="receiverVirtualIBAN">Receiver IBAN</label>
                <input class="form-control" readonly id="receiverVirtualIBAN" type="text" [(ngModel)]="searchedSuperTransaction.receiverVirtualIBAN"
                    name="receiverVirtualIBAN">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="currency">Currency</label>
                <input class="form-control" readonly id="currency" type="text" [(ngModel)]="searchedSuperTransaction.currency"
                    name="currency">
            </div>
            <div class="col-sm-4">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="originalAmount">Amount</label>
                <input class="form-control" readonly id="originalAmount" type="text" [(ngModel)]="searchedSuperTransaction.originalAmount"
                    name="originalAmount">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="originalFee">Fee</label>
                <input class="form-control" readonly id="originalFee" type="text" [(ngModel)]="searchedSuperTransaction.originalFee"
                    name="originalFee">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="originalVat">VAT</label>
                <input class="form-control" readonly id="originalVat" type="text" [(ngModel)]="searchedSuperTransaction.originalVat"
                    name="originalVat">
            </div>

        </div>
        <div class="row">
            <div class="col-sm-4">
                <label class="col-form-label" for="amountAmount">Amount</label>
                <input class="form-control" readonly id="amountAmount" type="text" [(ngModel)]="searchedSuperTransaction.amount.amount"
                    name="amountAmount">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="amountNarration">Narration</label>
                <input class="form-control" readonly id="amountNarration" type="text" [(ngModel)]="searchedSuperTransaction.amount.narration"
                    name="amountNarration">
            </div>
            <div class="col-sm-4">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="feeAmount">Fee</label>
                <input class="form-control" readonly id="feeAmount" type="text" [(ngModel)]="searchedSuperTransaction.fee.amount"
                    name="feeAmount">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="feeNarration">Narration</label>
                <input class="form-control" readonly id="feeNarration" type="text"
                    [(ngModel)]="searchedSuperTransaction.fee.narration" name="feeNarration">
            </div>
            <div class="col-sm-4">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="vatAmount">VAT</label>
                <input class="form-control" readonly id="vatAmount" type="text" [(ngModel)]="searchedSuperTransaction.vat.amount"
                    name="vatAmount">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="vatNarration">Narration</label>
                <input class="form-control" readonly id="vatNarration" type="text"
                    [(ngModel)]="searchedSuperTransaction.vat.narration" name="vatNarration">
            </div>
            <div class="col-sm-4">
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <label class="col-form-label" for="reason">Reason</label>
                <input class="form-control" readonly id="reason" type="text"
                    [(ngModel)]="searchedSuperTransaction.reason" name="reason">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="remarks">Remarks</label>
                <input class="form-control" readonly id="remarks" type="text" [(ngModel)]="searchedSuperTransaction.remarks"
                    name="remarks">
            </div>
            <div class="col-sm-4">
                <label class="col-form-label" for="reason">Message</label>
                <input class="form-control" readonly id="message" type="text" [(ngModel)]="searchedSuperTransaction.message"
                    name="message">
            </div>
        </div>
    </div>
</app-modal>